import { post } from '@/utils/request'

export function taoke_welcome() {
  return post('taoke_welcome')
}

export function oem_info(data) {
  return post('oem_info', data)
}

export function cms_items_list(data) {
  return post('cms_items_list', data)
}